// extracted by mini-css-extract-plugin
module.exports = {"Modal":"BaseModal_Modal__1sAFM","Body":"BaseModal_Body__3bNDc","IconBtn":"BaseModal_IconBtn__1aMlH","Icon":"BaseModal_Icon__2S7Uy"};